import React from 'react';
import '/node_modules/flag-icons/css/flag-icons.min.css';
import { CountryCode } from './CountrySelect';

export interface FlagProp extends React.HTMLProps<HTMLSpanElement> {
  nationality?: CountryCode | string;
}

export const Flag = ({ nationality, ...rest }: FlagProp) => (
  <span
    {...rest}
    style={{ width: '30px', height: '20px', minWidth: '30px', minHeight: '20px', ...rest?.style }}
    className={`fi fi-${nationality?.toLowerCase()}`}
  />
);
